import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkMode = new BehaviorSubject<boolean>(false);
  public darkMode$ = this.darkMode.asObservable();

  constructor() {
    // Check if dark mode is already active
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    const savedTheme = localStorage.getItem('darkMode');

    // Initialize dark mode based on saved preference or system preference
    if (savedTheme !== null) {
      this.setDarkMode(savedTheme === 'true');
    } else {
      this.setDarkMode(prefersDark.matches);
    }

    // Listen for changes in system preference
    prefersDark.addEventListener('change', (mediaQuery) => {
      if (localStorage.getItem('darkMode') === null) {
        this.setDarkMode(mediaQuery.matches);
      }
    });
  }

  setDarkMode(isDark: boolean) {
    console.log('ThemeService: Setting dark mode to', isDark);
    this.darkMode.next(isDark);

    // Remove both classes first
    document.body.classList.remove('dark', 'light');
    console.log('ThemeService: Removed theme classes, current classes:', document.body.classList.toString());

    // Add the appropriate class
    if (isDark) {
      document.body.classList.add('dark');
      console.log('ThemeService: Added dark class');
    } else {
      document.body.classList.add('light');
      console.log('ThemeService: Added light class');
    }

    console.log('ThemeService: Final body classes:', document.body.classList.toString());

    localStorage.setItem('darkMode', isDark.toString());
  }

  toggleDarkMode() {
    this.setDarkMode(!this.darkMode.value);
  }
}
